<template>
  <div class="more-page">
    <NavBar />

    <div class="more-container">
      <h4 class="page-title">More Options</h4>

      <div class="menu-list">
        <div class="menu-section">
          <div class="section-title">Reports</div>
          <button class="menu-item" @click="goTo('/report')">
            <div class="menu-icon reports"><i class="bi bi-calendar3"></i></div>
            <span class="menu-label">Monthly Report</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
          <button class="menu-item" @click="goTo('/fundsreport')">
            <div class="menu-icon funds"><i class="bi bi-wallet2"></i></div>
            <span class="menu-label">Funds Report</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
        </div>

        <div class="menu-section">
          <div class="section-title">Account</div>
          <button class="menu-item" @click="goTo('/profile')">
            <div class="menu-icon profile"><i class="bi bi-person"></i></div>
            <span class="menu-label">Profile</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
          <button class="menu-item" @click="openVirtualMoney">
            <div class="menu-icon virtual"><i class="bi bi-cash-stack"></i></div>
            <span class="menu-label">Set Virtual Money</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
          <button class="menu-item" @click="clearHistory">
            <div class="menu-icon clear"><i class="bi bi-trash"></i></div>
            <span class="menu-label">Clear History</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
        </div>

        <div class="menu-section">
          <div class="section-title">Support</div>
          <button class="menu-item" @click="$store.commit('setFeedback', true)">
            <div class="menu-icon feedback"><i class="bi bi-chat-dots"></i></div>
            <span class="menu-label">Feedback</span>
            <i class="bi bi-chevron-right menu-arrow"></i>
          </button>
        </div>

        <div class="menu-section">
          <button class="menu-item logout" @click="logout">
            <div class="menu-icon logout-icon"><i class="bi bi-box-arrow-right"></i></div>
            <span class="menu-label">Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/main/NavBar.vue'

export default {
  name: 'More',
  components: {
    NavBar
  },
  methods: {
    goTo (path) {
      // Use Vue Router navigation (preferred)
      this.$router.push(path)
    },

    clearHistory () {
      // Option 1: Vuex / Pinia
      if (this.$store) {
        this.$store.commit('setClearHistory', true)
      }
    },

    openVirtualMoney () {
      if (this.$store) {
        this.$store.commit('setVirtualMoney', true)
      }
    },

    logout () {
      // Your logout logic
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('token')
      this.$router.push('/signin')
    }
  }
}
</script>

<style scoped>
.more-page {
  min-height: 100vh;
  background-color: var(--bs-body-bg);
}

.more-container {
  padding: 20px 16px;
  padding-bottom: 100px;
  max-width: 600px;
  margin: 0 auto;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--bs-body-color);
  margin-bottom: 24px;
  text-align: center;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu-section {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 16px 8px;
}

.menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  background: transparent;
  border: none;
  border-top: 1px solid var(--bs-border-color);
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
}

.menu-section .menu-item:first-child,
.menu-section .section-title + .menu-item {
  border-top: none;
}

.menu-item:hover {
  background: var(--bs-tertiary-bg);
}

.menu-item:active {
  background: var(--bs-secondary-bg);
}

.menu-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}

.menu-icon i {
  font-size: 18px;
}

.menu-icon.reports {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.menu-icon.funds {
  background: rgba(102, 16, 242, 0.1);
  color: #6610f2;
}

.menu-icon.profile {
  background: rgba(32, 201, 151, 0.1);
  color: #20c997;
}

.menu-icon.virtual {
  background: rgba(11, 218, 81, 0.1);
  color: #0BDA51;
}

.menu-icon.clear {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.menu-icon.feedback {
  background: rgba(13, 202, 240, 0.1);
  color: #0dcaf0;
}

.menu-icon.logout-icon {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.menu-label {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: var(--bs-body-color);
}

.menu-arrow {
  color: var(--bs-secondary-color);
  font-size: 14px;
}

.menu-item.logout .menu-label {
  color: #dc3545;
}

/* Mobile optimizations */
@media (max-width: 480px) {
  .more-container {
    padding: 16px 12px;
    padding-bottom: 100px;
  }

  .page-title {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .menu-item {
    padding: 12px 14px;
  }

  .menu-icon {
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }

  .menu-icon i {
    font-size: 16px;
  }

  .menu-label {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/android/More.vue